
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { BlogPost } from "@/types/blog";

interface BlogPostNavigationProps {
  previousPost: BlogPost | null;
  nextPost: BlogPost | null;
}

const BlogPostNavigation: React.FC<BlogPostNavigationProps> = ({ previousPost, nextPost }) => {
  return (
    <div className="mt-12 border-t border-joerg-100 pt-8 grid grid-cols-1 sm:grid-cols-2 gap-8">
      {previousPost && (
        <div className="flex flex-col">
          <span className="text-sm text-joerg-500">Vorheriger Beitrag</span>
          <Link 
            to={`/blog/${previousPost.slug}`}
            className="mt-2 text-lg font-medium text-joerg-800 hover:text-primary group flex items-start"
          >
            <ArrowLeft className="mr-2 h-5 w-5 text-joerg-500 group-hover:text-primary mt-1 flex-shrink-0" />
            <span>{previousPost.title}</span>
          </Link>
        </div>
      )}
      
      {nextPost && (
        <div className="flex flex-col sm:items-end">
          <span className="text-sm text-joerg-500">Nächster Beitrag</span>
          <Link 
            to={`/blog/${nextPost.slug}`}
            className="mt-2 text-lg font-medium text-joerg-800 hover:text-primary group flex items-start sm:items-end justify-end"
          >
            <span>{nextPost.title}</span>
            <ArrowRight className="ml-2 h-5 w-5 text-joerg-500 group-hover:text-primary mt-1 flex-shrink-0" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default BlogPostNavigation;
